module.exports = "<i :class=\"['material-icons', size]\">{{value}}</i>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/icons/icon.vue
 ** module id = 52
 ** module chunks = 0
 **/